import { render, staticRenderFns } from "./TestPaperList.vue?vue&type=template&id=2543738c&scoped=true"
import script from "./TestPaperList.vue?vue&type=script&lang=js"
export * from "./TestPaperList.vue?vue&type=script&lang=js"
import style0 from "./TestPaperList.vue?vue&type=style&index=0&id=2543738c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543738c",
  null
  
)

export default component.exports